import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
//import reactStringReplace from 'react-string-replace';

import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

//////////////////////////////////////////////QUEY SECTION START////////////////////////////////////////////////////

//Add Home
const GQLAddNeighbourSearch = gql`
  mutation addNeighbourSearch(
    $userId: String
    $schoolScore: Float
    $crimeRate: Float
    $walkability: Float
    $towncenter: Float
    $curbAppeal: Float
    $publicspaces: Float
    $valueIndex: Float
    $pricemax: Float
    $pricemin: Float
  ) {
    createNeighbourSearch(
      userId: $userId
      schoolScore: $schoolScore
      crimeRate: $crimeRate
      walkability: $walkability
      towncenter: $towncenter
      curbAppeal: $curbAppeal
      publicspaces: $publicspaces
      valueIndex: $valueIndex
      pricemax: $pricemax
      pricemin: $pricemin
    ) {
      success
      message
    }
  }
`;

const GQLupdateNeighborSearch = gql`
  mutation updateNeighbourSearch(
    $userId: String
    $schoolScore: Float
    $crimeRate: Float
    $walkability: Float
    $towncenter: Float
    $curbAppeal: Float
    $publicspaces: Float
    $valueIndex: Float
    $pricemax: Float
    $pricemin: Float
  ) {
    updateNeighbourSearch(
      userId: $userId
      schoolScore: $schoolScore
      crimeRate: $crimeRate
      walkability: $walkability
      towncenter: $towncenter
      curbAppeal: $curbAppeal
      publicspaces: $publicspaces
      valueIndex: $valueIndex
      pricemax: $pricemax
      pricemin: $pricemin
    ) {
      success
      message
    }
  }
`;

const QUERY_GetNeighborSearch = gql`
  query getneighborsearch(
    $start: Int
    $limit: Int
    $orderBy: String
    $order: String
    $fields: String
  ) {
    getneighborsearch(
      start: $start
      limit: $limit
      orderBy: $orderBy
      order: $order
      fields: $fields
    ) {
      userId
      schoolScore
      crimeRate
      walkability
      towncenter
      curbAppeal
      publicspaces
      valueIndex
      pricemax
      pricemin
    }
  }
`;

//////////////////////////////////////////////QUEY SECTION WRAP////////////////////////////////////////////////////

//////////////////////////////////////////////FUNCTION SECTION START////////////////////////////////////////////////////

//Add NeighbourSearch Function

async function addNeighbourSearch(adddata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLAddNeighbourSearch,

        variables: {
          userId: adddata.userId,
          schoolScore: adddata.schoolScore,
          crimeRate: adddata.crimeRate,
          walkability: adddata.walkability,
          towncenter: adddata.towncenter,
          curbAppeal: adddata.curbAppeal,
          publicspaces: adddata.publicspaces,
          valueIndex: adddata.valueIndex,
          pricemax: adddata.pricemax,
          pricemin: adddata.pricemin,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getNeighborSearch(getdata) {
  return new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_GetNeighborSearch,
        options: {
          fetch: fetch,
        },
        variables: {
          start: getdata.start,
          limit: getdata.limit,
          orderBy: getdata.orderBy,
          order: getdata.order,
          fields: JSON.stringify(getdata.fields),
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateNeighborSearch(updatedata) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLupdateNeighborSearch,
        variables: {
          userId: updatedata.userId,
          schoolScore: updatedata.schoolScore,
          crimeRate: updatedata.crimeRate,
          walkability: updatedata.walkability,
          towncenter: updatedata.towncenter,
          curbAppeal: updatedata.curbAppeal,
          publicspaces: updatedata.publicspaces,
          valueIndex: updatedata.valueIndex,
          pricemax: updatedata.pricemax,
          pricemin: updatedata.pricemin,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

//////////////////////////////////////////////FUNCTION SECTION WRAP////////////////////////////////////////////////////

export { addNeighbourSearch, getNeighborSearch, updateNeighborSearch };
